import { Button, useModal } from "@shortsworks/ui";
import { useLocation, useNavigate } from "react-router-dom";
import { useFormWithSchema } from "@app/components/forms/hooks/useFormWithSchema";
import { getApiKeyWithCustomerLogin } from "@shortsworks/user-api";
import { CommonErrorModal } from "@app/components/modals/CommonErrorModal";
import FormContainer from "@app/components/forms/container/FormContainer";
import { BlogpaySchema } from "@app/pages/auth/Signup/blogpaySchema";
import { PlatformType } from "@app/types/platform";

export const BlogpayLoginForm = () => {
  const { showModal } = useModal();

  const location = useLocation();
  const navigate = useNavigate();

  const { form, schemas, parseForm } = useFormWithSchema({
    formSchemas: BlogpaySchema,
    mode: "onChange",
  });
  const goPrevious = () => {
    return navigate("/signup/step3");
  };

  const goNext = async () => {
    const parsedForm = parseForm();
    if (!parsedForm.success) {
      return;
    }

    const { id, password } = parsedForm.data;

    // 이미 존재하는 아이디인지 체크하는 로직도 필요
    const result = await getApiKeyWithCustomerLogin({
      id,
      password,
      mallId: id,
      platformType: PlatformType.BLOGPAY,
    });
    const token = result.data.token;
    if (typeof token === "undefined") {
      return showModal(CommonErrorModal, {
        title:
          "블로그페이 로그인에 실패했습니다. 아이디와 비밀번호를 확인해주세요.",
      });
    }

    return navigate("/signup/step4", {
      state: {
        ...location.state,
      },
    });
  };

  return (
    <div>
      <h1 className="mb-4 text-xl font-bold">블로그페이 연동하기</h1>
      <FormContainer schemas={schemas} form={form} />
      <div className="mt-4 text-sm text-blue-400">
        블로그페이 아이디와 비밀번호는 블로그페이 API 키 발급을 위해 사용되며
        저장되지 않습니다.
      </div>
      <div className="flex flex-row w-full">
        <Button
          className="w-full mr-4"
          variant="secondary"
          onClick={goPrevious}
        >
          이전
        </Button>
        <Button className="w-full" onClick={goNext}>
          다음
        </Button>
      </div>
    </div>
  );
};
